module.exports = __webpack_public_path__ + "img/paved_paved.e937181f.png";